export default __webpack_public_path__ + "static/media/gamepad.a7d81632.svg";